var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _bindInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/bind");

var _context;

var DomUtils = module.exports;

_forEachInstanceProperty(_context = [require("./lib/stringify"), require("./lib/traversal"), require("./lib/manipulation"), require("./lib/querying"), require("./lib/legacy"), require("./lib/helpers")]).call(_context, function (ext) {
  var _context2;

  _forEachInstanceProperty(_context2 = _Object$keys(ext)).call(_context2, function (key) {
    var _context3;

    DomUtils[key] = _bindInstanceProperty(_context3 = ext[key]).call(_context3, DomUtils);
  });
});